export const genderData = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];


export const ageRangeData = [
  {
    label: "18-25",
    value: "18-25",
  },
  {
    label: "26-30",
    value: "26-30",
  },
  {
    label: "31-35",
    value: "31-35",
  },
  {
    label: "36 and above",
    value: "36 and above",
  },
];


export const openForumGhanaLocation = `SRC Conference Hall, Kumasi Technical University, Ghana`;
export const openForumNigeriaLocation = `Ibadan Business School, Off Awolowo Ave, Behind Davis Hotel, Old Bodija, Ibadan, Oyo State, Nigeria`;



export const eraconnecktEventCountryData = [
  {
    label: `${openForumGhanaLocation}`,
    value: `${openForumGhanaLocation}`,
  }
];

export const educationalQualification = [
  {
    label: "A Graduate",
    value: "Graduate",
  },
  {
    label: "An Undergraduate",
    value: "Undergraduate",
  },
  {
    label: "A SSCE Holder",
    value: "SSCE Holder",
  },
  {
    label: "Other",
    value: "Other(specify)",
  },
];

export const employmentStatus = [
  {
    label: "Employed",
    value: "Employed",
  },
  {
    label: "Unemployed",
    value: "Unemployed",
  },
  {
    label: "Freelancing",
    value: "Freelancing",
  },
  {
    label: "Interning",
    value: "Interning",
  },
  {
    label: "An Entrepreneur",
    value: "An Entrepreneur",
  },
];

export const digitalLiteracyLevel = [
  {
    label: "Basic",
    value: "Basic",
  },
  {
    label: "Intermediate",
    value: "Intermediate",
  },
  {
    label: "Advanced",
    value: "Advanced",
  },
];

export const technicalSkills = [
  {
    label: "Beginner",
    value: "Beginner",
  },
  {
    label: "Intermediate",
    value: "Intermediate",
  },
  {
    label: "Advanced",
    value: "Advanced",
  },
  {
    label: "Expert",
    value: "Expert",
  },
];

export const experienceDigitalTools = [
  {
    label: "0-6 months",
    value: "6months",
  },
  {
    label: "6-12 months",
    value: "12months",
  },
  {
    label: "1-2 years",
    value: "2years",
  },
  {
    label: "2-5 years",
    value: "2+years",
  },
  {
    label: "5+ years",
    value: ">5years",
  },
];

export const currentDeviceUsed = [
  {
    label: "Desktop Computer",
    value: "Desktop Computer",
  },
  {
    label: "Laptop",
    value: "Laptop",
  },
  {
    label: "Smart Phone",
    value: "Smart Phone",
  },
  {
    label: "Tablet",
    value: "Tablet",
  },
  {
    label: "I do not own or have access to a functioning device",
    value: "No Device",
  },
];

export const digitalTraining = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

export const internShipTraining = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];


export const adoptSkill = [
  {
    label: "Product Design",
    value: "Product Design",
  },
  {
    label: "Project Management",
    value: "Project Management",
  },
  {
    label: "Cyber Security",
    value: "Cyber Security",
  },
  {
    label: "Data Science",
    value: "Data Science",
  },
  {
    label: "Software Development",
    value: "Software Development",
  },
  {
    label: "Blockchain Development",
    value: "Blockchain Development",
  },
  {
    label: "Cloud Computing",
    value: "Cloud Computing",
  },
  {
    label: "Artificial Intelligence and Machine Learning",
    value: "Artificial Intelligence and Machine Learning",
  },
  {
    label: "Devops & Systems Administration",
    value: "Devops",
  },
  {
    label: "IT Support and Networking",
    value: "IT Support and Networking",
  },
  {
    label: "Robotics and IoT",
    value: "Robotics",
  },
];